import { MDSIcon } from "@/mds/components/icon";
import styled from "@emotion/styled";
import { Checkbox, CheckboxGroup } from "react-aria-components";

export const StyledCheckbox = styled(Checkbox)`
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  /*
   * Default styling for a bare-text label. Consumers that pass their own
   * styled children (e.g. MDSText) still win via the cascade, so this only
   * affects labels rendered as raw strings. Matches Figma spec text/small,
   * smedium, text/primary (theme-aware so it stays visible in dark mode).
   * cursor: pointer keeps the hand cursor consistent across the indicator
   * and the label instead of flipping to the default arrow over the text.
   */
  & label {
    cursor: pointer;
    color: ${({ theme }) => theme.colors.text.primary};
    font-size: ${({ theme }) => theme.fontSizes["text-s"]};
    font-weight: ${({ theme }) => theme.fontWeights.smedium};
    line-height: ${({ theme }) => theme.lineHeights["text-s"]};
  }

  &[data-disabled] {
    cursor: default;
    opacity: 0.5;
  }
`;

export const StyledIndicator = styled.div`
  padding: ${({ theme }) => theme.spacing["2"]};

  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  [data-focus-visible] & {
    outline: 2px solid ${({ theme }) => theme.colors.background.input.default.focused};
    outline-offset: 2px;
  }
`;

export const StyledCheckboxGroup = styled(CheckboxGroup)`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing["2"]};

  [slot="label"] {
    font-weight: ${({ theme }) => theme.fontWeights.semiBold};
    font-size: ${({ theme }) => theme.fontSizes["paragraph-s"]};
    margin-bottom: ${({ theme }) => theme.spacing["1"]};
  }

  [slot="description"] {
    font-size: ${({ theme }) => theme.fontSizes["text-s"]};
    color: ${({ theme }) => theme.colors.text.secondary};
    margin-bottom: ${({ theme }) => theme.spacing["1"]};
  }

  [slot="errorMessage"] {
    font-size: ${({ theme }) => theme.fontSizes["text-s"]};
    color: ${({ theme }) => theme.colors.text.danger};
    margin-top: ${({ theme }) => theme.spacing["1"]};
  }
`;

export const StyledCheckboxIcon = styled(MDSIcon)`
  width: 16px;
  height: 16px;

  .mds-icon {
    width: 16px;
    height: 16px;
    transition: all 200ms;
  }
`;
